<template lang="pug">
  b-modal(
    size="lg",
    v-model="open",
    header-class="lmm-common-popup-header")
    template(#modal-header)
      span.title {{$t('remote.preview.title')}}
      img.logo(src="../../assets/main_logo.svg" style="height: 20px")
    div.image-wrap
      div.offline-block(v-if="alive != 1")
        div OFFLINE
      l-image(:src="source", :placeholder="`${AppState.Path.image}/live/live_no_img.jpg`", contain)
    template(v-slot:modal-footer)
      b-btn(
        size="sm",
        @click="open = false")
        | {{$t('close')}}
</template>

<script>
export default {
  name: 'liveview-dialog',
  props: ['show', 'source', 'alive'],
  computed: {
    open: {
      get () {
        return this.show
      },
      set (n) {
        this.$emit('change', n)
      }
    }
  },
  methods: {
    loaded () {
      this.isBroken = false
    },
    fallback () {
      this.isBroken = true
    }
  },
  data () {
    return {
      isBroken: true
    }
  }
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>
<style scoped lang="scss">
.title {
  font-size: 20px;
  font-weight: 500;
  color: #f0f0f0;
  line-height: 100%;
  letter-spacing: -.5px;
}
</style>
